// Catalogue des marchés suivables (watchlist). Chaque actif relie les 3 sources:
// - ccy: code devise pour le calendrier économique
// - cot: code marché CFTC (voir backend COT_MARKETS)
// - keywords: mots-clés pour filtrer le flux d'actualités
export const ASSETS = [
  { id: "gold", label: "Or", labelEn: "Gold", flag: "🥇", cot: "OR", keywords: ["gold", "xau", "bullion", "precious metal", " or "] },
  { id: "silver", label: "Argent", labelEn: "Silver", flag: "🥈", cot: "ARGENT", keywords: ["silver", "xag"] },
  { id: "oil", label: "Pétrole", labelEn: "Oil", flag: "🛢️", cot: "PÉTROLE", keywords: ["oil", "crude", "wti", "brent", "opec", "pétrole"] },
  { id: "usd", label: "USD", flag: "🇺🇸", ccy: "USD", cot: "USD", keywords: ["dollar", "fed", "fomc", "powell", "treasury", "usd"] },
  { id: "eur", label: "EUR", flag: "🇪🇺", ccy: "EUR", cot: "EUR", keywords: ["euro", "ecb", "bce", "eurozone", "eur/usd", "lagarde"] },
  { id: "gbp", label: "GBP", flag: "🇬🇧", ccy: "GBP", cot: "GBP", keywords: ["pound", "sterling", "boe", "gbp", "britain"] },
  { id: "jpy", label: "JPY", flag: "🇯🇵", ccy: "JPY", cot: "JPY", keywords: ["yen", "boj", "japan", "jpy", "ueda"] },
  { id: "chf", label: "CHF", flag: "🇨🇭", ccy: "CHF", cot: "CHF", keywords: ["franc", "snb", "swiss", "chf"] },
  { id: "cad", label: "CAD", flag: "🇨🇦", ccy: "CAD", cot: "CAD", keywords: ["loonie", "boc", "canada", "cad"] },
  { id: "aud", label: "AUD", flag: "🇦🇺", ccy: "AUD", cot: "AUD", keywords: ["aussie", "rba", "australia", "aud"] },
  { id: "nzd", label: "NZD", flag: "🇳🇿", ccy: "NZD", cot: "NZD", keywords: ["kiwi", "rbnz", "new zealand", "nzd"] },
  { id: "sp500", label: "S&P 500", flag: "📈", cot: "S&P 500", keywords: ["s&p", "sp500", "equities", "wall street", "stocks"] },
  { id: "nasdaq", label: "Nasdaq", flag: "💻", cot: "NASDAQ", keywords: ["nasdaq", "tech stocks", "big tech"] },
  { id: "btc", label: "Bitcoin", flag: "₿", cot: "BTC", keywords: ["bitcoin", "btc", "crypto", "ethereum"] },
  { id: "us10y", label: "US 10A", flag: "🏦", cot: "US 10A", keywords: ["treasury", "yield", "10-year", "bond", "taux"] },
];

export const ASSET_MAP = Object.fromEntries(ASSETS.map((a) => [a.id, a]));

export const watchedAssets = (wl) => (wl || []).map((id) => ASSET_MAP[id]).filter(Boolean);
export const watchedCcys = (wl) => [...new Set(watchedAssets(wl).map((a) => a.ccy).filter(Boolean))];
export const watchedCotCodes = (wl) => watchedAssets(wl).map((a) => a.cot).filter(Boolean);
export const watchedKeywords = (wl) => watchedAssets(wl).flatMap((a) => a.keywords || []);

export const matchesWatchlist = (text, wl) => {
  const kws = watchedKeywords(wl);
  if (!kws.length) return true;
  const t = (text || "").toLowerCase();
  return kws.some((k) => t.includes(k));
};
